
<template>
<b-modal
    ref="modal"
    id="agImportModal"
    class="agModal"
    :class="{'agModal-loading':isLoading}"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="importButton_click">
    <template slot="modal-header">
      <h4 class="agModal-title">Import Workflow</h4>
    </template>
    <div class="agInputGroup">
        <label>Workspace:</label>
        <b-form-select 
          class="agMediumInput"
          v-model="workspace"
          :options="workspaceOptions"
          :disabled="isLoading"
          :state="hasError('workspace')">
        </b-form-select>
    </div>
    <div class="agInputGroup">
        <label>Name:</label>
        <b-input
          class="agMediumInput"
          v-model="name"
          :disabled="isLoading"
          :state="hasError('name')">
        </b-input>
    </div>
     <b-form-textarea
      ref="text"
      id="agImportModal-text"
      v-model="importText"
      no-resize
      :disabled="isLoading"
      :state="hasError('text')">
    </b-form-textarea>
    <div v-if="modalMessage">
      <hr>
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button class="agModal-buttonRight" variant="primary" :disabled="isLoading" @click="importButton_click">Import</b-button>
    </template>
  </b-modal>
</template>






<script>

// components


// modules
import Server from "src/server";


export default {
    name: "ag-import-modal",

    components: {

    },

    props:{
        workflow: Object,
    },

    data(){
        return {
            isLoading: false,
            modalMessage: "",
            modalMessageClass: "",
            errorField: "",
            workspace: "",
            workspaceOptions: [],
            name: "",
            importText: "",
            workflows: [],
        };
    },

    computed: {

        workspaces() {
            return this.$store.getters["wsStore/userWorkspaces"];
        },

    },
    
    watch: {
      async workspace() {
          this.workflows = [];

          if(this.workspace) {
            try {
                var result = await Server.post("getWorkflows", { workspace: this.workspace }).promise;
                if(!result.data.success)
                    throw(result.data.error);

                this.workflows = result.data.workflows;
            }
            catch(e) {
                console.log("Failed 'getWorkflows' server call. " + e.toString());
             }
          }
      }
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        
        async importButton_click() {

            if(!this.validate()) {
                return;
            }

            try {
                var workflow = JSON.parse(this.importText);
            }
            catch(e) {
                this.modalMessage = "Failed to parse workflow text";
                this.modalMessageClass = "agModal-errorMessage";
                return;
            }

            workflow.name = this.name;

            this.isLoading = true;
            var result = await this.$store.dispatch("wfStore/importWorkflow", {workflow: workflow, workspace: this.workspace});
            this.isLoading = false;
            if(result.data.success) {
                this.hide();
                this.$emit("reloadWorkflows");
            }
            else {
                this.modalMessage = "Failed to import workflow. Error: " + result.data.error;
                this.modalMessageClass = "agModal-errorMessage";
            }          
        },

        // emitted Events


        // other

        show() {
            setTimeout(() => {
                this.reset();
                this.$refs.modal.show();
            }, 250);
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          this.modalMessage = "";
          this.modalMessageClass = "";
          this.errorField = "";
          this.importText = "";
          this.workspace = "";
          this.name = "";
          this.setWorkspaceOptions();
        },

        hasError(field) {
            if (field == this.errorField) {
                return false; // false = error
            }
            return null;
        },

        validate()
        {
            this.modalMessage = "";
            this.modalMessageClass = "";
            this.errorField = "";

            if(!this.workspace) {
                this.modalMessage = "A workspace must be selected";
                this.modalMessageClass = "agModal-errorMessage";
                this.errorField = "workspace";
                return false;
            }

            if(!this.name) {
                this.modalMessage = "The new workflow must be named";
                this.modalMessageClass = "agModal-errorMessage";
                this.errorField = "name";
                return false;
            }

            if(!this.importText) {
                this.modalMessage = "A workflow in text form is required";
                this.modalMessageClass = "agModal-errorMessage";
                this.errorField = "text";
                return false;
            }


            return true;
        },

        setWorkspaceOptions() {
            this.workspaceOptions = [];
            for(var i = 0; i < this.workspaces.length; i++) {
                var workspace = this.workspaces[i];
                this.workspaceOptions.push({value: workspace._id, text: workspace.name});
            }
        },
    }
}

</script>






<style scoped lang="css">

#agImportModal-text {
    height: 400px;
}


</style>



// WEBPACK FOOTER //
// src/components/workflow/ImportModal.vue